// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadAccountsIfNeeded from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/LoadAccountsIfNeeded";
import { MetaDescription, MetaKeywords } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Page from "@insite/mobius/Page";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    loadAccountsIfNeeded,
};

const mapStateToProps = (state: ApplicationState) => ({
    cartState: getCurrentCartState(state),
    isUpdatingCartLine: state.pages.cart.isUpdatingCartLine,
});

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;

export interface RfqRequestQuotePageStyles {
    loadingOverlay?: LoadingOverlayProps;
}

export const rfqRequestQuotePageStyles: RfqRequestQuotePageStyles = {
    loadingOverlay: {
        css: css`
            width: 100%;
        `,
    },
};

const styles = rfqRequestQuotePageStyles;

const RfqRequestQuotePage = ({ id, cartState, isUpdatingCartLine, loadAccountsIfNeeded }: Props) => {
    useEffect(() => {
        loadAccountsIfNeeded();
    }, [cartState]);

    return (
        <Page>
            <LoadingOverlay {...styles.loadingOverlay} loading={cartState.isLoading || isUpdatingCartLine}>
                <Zone contentId={id} zoneName="Content" />
            </LoadingOverlay>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqRequestQuotePage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        // XNG-Changes
        fieldDefinitions: [MetaKeywords, MetaDescription],
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RfqRequestQuotePage" instead of this constant.
 */
export const RfqRequestQuotePageContext = "RfqRequestQuotePage";

